export class UserSession {

    id:  string
    accessToken: string
    username:  string
    firstname:  string
    lastname:  string
    emailid:  string
    title:  string
    identificationnumber:  string
    primarycontactnumber:  string
    landlinenumber:  string
    mobilenumber:  string
    roletype:  number
    roleId:  string
    userStatusType:  string
    refrenceNumber:  string
    gender:  string
    dateofBirth:  string
    roleDetails:  string
    resellerCode:  string
    salesRepId:  string
    homeLanguage:  string
    authenticationStatus:  string
    expiresUtc:  string
    isPasswordChangedWithInThreeMonth: string
}
